// extracted by mini-css-extract-plugin
module.exports = {"products-grid":"scss_products-grid__3QcQh"};